const React = require('react');
const SharedModels = require('../../../../shared/sharedModels');
const MultiLineTextField = require('./commonControls.jsx.js').MultiLineTextField;
const Toastr = require('toastr');
const AjaxFunctions = require('./../ajaxFunctions.js');
const ReduxStore = require('./../redux/reduxStore.jsx.js');
const connect = require('react-redux/dist/react-redux.min.js').connect;
const PropTypes = require('prop-types');
const LocalStorage = require('../localStorage.js');
const Link = require('react-router-dom').Link;
const Utils = require('../utils');
const SharedConstants = require('../../../../shared/sharedConstants');

import Button from '@material-ui/core/Button';
import Select from 'react-select';

class ConjectureCreationBase extends React.Component{
   constructor(props) {
      super(props);
      let savedState = null;
      try {
         savedState = JSON.parse(LocalStorage.getItem('conjectureCreationState'));
      }
      catch (e) {
         console.log('could not load saved conjecture creation state');
      }
      if(savedState){
         this.state = savedState;
         if(savedState.evidenceToLink){
            for(let evidence of savedState.evidenceToLink){
               this.props.addToCreation(evidence);
            }
         }
      }
      else{
         this.state = {
            enteredText: '',
            isWaitingOnSubmit: false,
            submitButtonText: 'Submit',
            tags: '',
            portfolio: '',
         }
      }
      this.state.curUserSelection = [];
   }

   async componentDidMount(){
      this.props.setShowLinkBtn(true);
   }

   clearCardInput(){
      document.getElementById('cardCreationConjectureSynopsis').value = '';
      document.getElementById('cardCreationConjectureTags').value = '';

      this.props.setEvidence([]);

      this.setState({
         enteredText: '',
         tags: '',
         evidenceToLink: [],
         curUserSelection: [],
         portfolio: '',
      });

      let toSaveState = {...this.state};
      LocalStorage.setItem('conjectureCreationState', JSON.stringify(toSaveState));
   }

   getTags() {
      return this.state.tags
         .toLowerCase()
         .split(',')
         .filter(tag => tag.trim())
         .map(tag => tag.trim());
   }

   async createConjecture(){
      if(!this.isCardValid()){
         return;
      }

      if(!window.globals.idUser){
         Toastr.options.positionClass = 'toast-bottom-full-width';
         Toastr.error('Only Registered Users Can Create Conjecture.');
         document.getElementById('btnNavBarSignIn').click();
         return;
      }

      this.setState({isWaitingOnSubmit: true, submitButtonText: 'Creating. . .'});

      let card = {
         title: this.state.enteredText,
         idEvidenceCard1: parseInt(this.props.evidenceToLink[0].id),
         idEvidenceCard2: parseInt(this.props.evidenceToLink[1].id),
         isPrivate: false,
         userSelection: [],

      };

      let rawTags = this.getTags();
      if(rawTags.length > 0){
         let tags = [];
         for(let tag of rawTags){
            tags.push(new SharedModels.Tag({ text: tag }));
         }
         card.tags = tags;
      }

      for(let usr of this.state.curUserSelection){
         card.userSelection.push(usr.value);
      }

      AjaxFunctions.createReasoningCard(card).then(data =>{
         this.setState({isWaitingOnSubmit: false, submitButtonText: 'Submit'});
         Toastr.options.positionClass = 'toast-bottom-full-width';
         Toastr.success('Created Conjecture.');
         AjaxFunctions.getUnapprovedCards().then((list) => {
            ReduxStore.store.dispatch(ReduxStore.CardFunctions.setUnapproved(list));
         });
         if (this.state.portfolio.value) {
            AjaxFunctions.addCardToEndOfPortfolio(
               this.state.portfolio.value,
               data.idGreySpaceCard,
               SharedConstants.CardType.Reasoning
            );
         }
         this.clearCardInput();
         Utils.updateCurrentUserData();

         if(this.props.onCreate){
            this.props.onCreate(data.idGreySpaceCard);
         }

      })

   }

   isCardValid(){
      return this.state.enteredText.trim().length > 1
         && !this.state.isWaitingOnSubmit
         && this.props.evidenceToLink.length === 2;
   }

   onCancel(){
      this.props.setShowLinkBtn(false);
      this.props.onCancel();
   }

   onFieldChange(stateKey, stateValue){
      this.setState({[stateKey]: stateValue},() => {
         let toSaveState = {...this.state};
         toSaveState.evidenceToLink = this.props.evidenceToLink;
         LocalStorage.setItem('conjectureCreationState', JSON.stringify(toSaveState));
      })
   }

   onUserSelectionChanged(curUserSelection){
      this.setState({curUserSelection});
   }

   render() {
      let instructions = '';
      if(this.props.evidenceToLink.length === 0){
         instructions = 'Select two Evidence ' + String.fromCharCode(181) + 'Pubs from the list. Click Link next to ' +
            'any of the Evidence ' + String.fromCharCode(181) + 'Pubs to populate boxes 1 and 2';
      }
      else if(this.props.evidenceToLink.length === 1){
         instructions = 'Select one more ' + String.fromCharCode(181) + 'Pub from the list. Click Link next to ' +
            'any of the Evidence ' + String.fromCharCode(181) + 'Pubs to populate boxes 1 and 2';
      }
      else{
         instructions = 'Next, let us know how you think your selected evidence is related, to pick a different ' + String.fromCharCode(181)
            + 'Pub, remove one of ones currently selected';
      }

      let allUserOptions = [];
      if(this.state.curUserSelection.length <3) {
         for (let option of this.props.userSocialNetwork.followers) {
            allUserOptions.push({value: option.idUser, label: `${option.firstName} ${option.lastName}`});
         }
         for (let option of this.props.userSocialNetwork.followees) {
            allUserOptions.push({value: option.idUser, label: `${option.firstName} ${option.lastName}`});
         }
      }

      allUserOptions = Utils.removeDuplicatesFromArrayByProp(allUserOptions, 'value');


      return(
         <div id='conjectureCreationContainer'>
            <fieldset className='form__container'>
               {
                  !this.props.hideCancelButton &&
                  <div>
                     <Link to={'/listView'}>
                        <i
                           id='btnCancelCreation'
                           className='fa fa-times float-right'
                           onClick={() => this.onCancel()}
                        />
                     </Link>
                  </div>
               }
               <div id='conjectureCreationInstructions'>
                  {instructions}
               </div>
               <EvidencePreview
                  evidence={this.props.evidenceToLink[0] || {}}
                  removeFunction={(id) => this.props.removeFromCreation(id)}
               />
               <EvidencePreview
                  evidence={this.props.evidenceToLink[1] || {}}
                  removeFunction={(id) => this.props.removeFromCreation(id)}
               />
               <div>
                  <MultiLineTextField
                     idInput='cardCreationConjectureSynopsis'
                     data={this.state.enteredText}
                     onChange= {(event) => this.onFieldChange('enteredText', event.target.value)}
                     dataField= ''
                     checkForValidationErrors={false}
                     placeholder={'Summarize in a question or statement how these two Evidence µPubs could result in a new idea to investigate.'}
                     maxLength='250'
                     label='Summary'
                     InputLabelProps={{
                        shrink: true,
                     }}
                  />
                  <label htmlFor='cardCreationConjectureTags'>
                     Keywords (Comma Separated)
                  </label>
                  <input
                     id='cardCreationConjectureTags'
                     className='form__input'
                     placeholder={'Additional tags to describe the conjecture'}
                     value={this.state.tags}
                     onChange={ (event) => this.onFieldChange('tags', event.target.value) }
                     maxLength="300"
                  />
                  <label htmlFor='portfolio-text-input'>
                     Add to Incubator or Portfolio
                  </label>
                  <Select
                     closeMenuOnSelect
                     options={this.props.portfolioList.sort((a, b) => b.id - a.id).map(p => ({
                        value: p.id,
                        label: p.name,
                     }))}
                     value={this.state.portfolio}
                     onChange={value => this.onFieldChange('portfolio', value)}
                     id='portfolio-text-input'
                     placeholder='Select an incubator or portfolio'
                  />
               </div>
               <Button
                  color='primary'
                  id='btnCreationClear'
                  onClick={() => {
                     this.clearCardInput();
                     this.onFieldChange('','');
                  }}
               >
                  Clear Form
               </Button>
               <Button color='primary'>
                  <a href='https://youtu.be/wih4NmcAf3k' className={'noHoverDecorate'} target={"_blank"}>
                     Video Instructions
                  </a>
               </Button>
            </fieldset>
            <input
               id='btnEvidenceSubmit'
               className={this.isCardValid() ? 'active' : 'disabled'}
               type='submit'
               value={this.state.submitButtonText}
               onClick={() => this.createConjecture()}
            />
         </div>

      )
   }
}

ConjectureCreationBase.propTypes = {
   allTopics: PropTypes.array,
};

class EvidencePreview extends React.Component{
   constructor(props) {
      super(props);
   }

   render() {
      let helpText = () => {
         return(
            <span>
               Click an Evidence &micro;Pub's <i className="fas fa-link" /> icon to Add
            </span>
         )
      };
      let hasData = (typeof(this.props.evidence.id) !== 'undefined');
      return (
         <div className='conjecture-creation-evidence-preview'>
            {this.props.evidence.title || helpText()}
            {hasData === true
               ? <i className='fa fa-times float-right' onClick={() => this.props.removeFunction(this.props.evidence.id)} />
               : ''
            }

         </div>
      );
   }
}

const mapConjectureCreationStateToProps = (state) => {
   const { PortfolioReducer: { portfolioList } } = state;
   const curDate = new Date();
   let openSponsored = portfolioList.sponsored.filter(x =>
      x.privacyType === SharedConstants.PortfolioType.Sponsored && (new Date(x.incubatorEndTime ? x.incubatorEndTime: x.proposalDueTime) >= curDate)
   );
   let openPrivate = portfolioList.sponsored.filter(x =>
      x.privacyType === SharedConstants.PortfolioType.SponsoredPrivate && (new Date(x.incubatorEndTime ? x.incubatorEndTime: x.proposalDueTime) >= curDate)
   )
   const combined = [...openSponsored, ...openPrivate, ...portfolioList.owned];
   let ids = [];
   return {
      evidenceToLink: state.GreySpaceCardReducer.creationEvidence,
      userSocialNetwork: state.UserReducer.curUser.socialNetwork,
      portfolioList: combined.filter(p => {
         if (!ids.includes(p.id)) {
            ids.push(p.id);
            return true;
         } else {
            return false;
         }
      })
   }
};

const mapConjectureCreationDispatchToProps = (dispatch) => {
   return {
      removeFromCreation: (idEvidence) => {
         dispatch(ReduxStore.GreySpaceCardFunctions.removeEvidenceFromCreation(idEvidence));
      },
      addToCreation: (evidence) => {
         dispatch(ReduxStore.GreySpaceCardFunctions.addEvidenceToCreation(evidence));
      },
      setShowLinkBtn: (bVal) => {
         dispatch(ReduxStore.EditorFunctions.setShowLinkBtn(bVal));
      },
      setEvidence: (evidenceArray) => {
         dispatch(ReduxStore.GreySpaceCardFunctions.setCreationEvidence(evidenceArray));
      }
   }
};

export default connect(
   mapConjectureCreationStateToProps,
   mapConjectureCreationDispatchToProps
)(ConjectureCreationBase);

